import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { AlertTriangle } from "lucide-react";
import { useState } from "react";
import { motion } from "framer-motion";
import { useHistory } from "react-router-dom";

/**
 * Props for LowCreditsDialog
 * @param {boolean} open - Whether the dialog is open
 * @param {function} onOpenChange - Callback for dialog open state change
 * @param {string} title - Dialog title
 * @param {string} description - Dialog description/message
 * @param {string} buttonText - Button text (e.g. "Top up")
 * @param {function} onButtonClick - Callback for button click
 */
export default function LowCreditsDialog({
  open = true,
  onOpenChange,
  title = "Low Credits",
  description = "No available shares or credits to share chat session.",
  buttonText = "Top up",
  onButtonClick,
}) {
  const history = useHistory();
  const handleButtonClick = () => {
      history.push("/account/topup");
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex flex-col items-center max-w-md w-full">
        <div className="flex justify-center">
          <motion.div
            initial={{ scale: 1, opacity: 1 }}
            animate={{ scale: [1, 1.15, 1], opacity: [1, 0.7, 1] }}
            transition={{ duration: 1.2, repeat: Infinity, ease: "easeInOut" }}
            className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-orange-100 shadow-lg"
          >
            <AlertTriangle className="h-8 w-8 text-orange-500 animate-pulse" />
          </motion.div>
        </div>
        <DialogHeader className="text-center gap-0">
          <DialogTitle className="text-center">{title}</DialogTitle>
          <DialogDescription className="mt-2 text-center mx-auto sm:max-w-[90%]">
            {description}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:justify-center w-full">
          <DialogClose asChild>
            <Button className="w-[100%] mx-auto block" onClick={handleButtonClick}>{buttonText}</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
